module.exports = __webpack_public_path__ + "img/exclamation.38c6e393.svg";